// Email utility functions

/**
 * Creates a mailto link with encoded subject and body
 * @param {string} to - Recipient email address
 * @param {string} subject - Email subject
 * @param {string} body - Email body content
 * @returns {string} Formatted mailto link
 */
export const createMailtoLink = (to, subject = '', body = '') => {
  const params = [];
  
  if (subject) {
    params.push(`subject=${encodeURIComponent(subject)}`);
  }
  if (body) {
    params.push(`body=${encodeURIComponent(body)}`);
  }
  
  const queryString = params.join('&');
  return `mailto:${to}${queryString ? '?' + queryString : ''}`;
};

/**
 * Opens default email client with pre-filled information
 * @param {string} to - Recipient email address
 * @param {string} subject - Email subject
 * @param {string} body - Email body content
 */
export const openEmailClient = (to, subject = '', body = '') => {
  const mailtoLink = createMailtoLink(to, subject, body);
  window.location.href = mailtoLink;
};

const emailUtils = {
  createMailtoLink,
  openEmailClient
};

export default emailUtils;
